import React, { useState } from 'react';
import '../../../../styles/ScheduleTable.css';
import { useSport } from '../../../../context/SportContext.tsx';
import { FutureGames } from './FutureGames.tsx';
import AlertError from '../../../alerts/AlertError.tsx';
import { useModal } from '../../../../context/ModalContext.tsx';
import { BetDetails } from '../../../../models/MyBetModel.tsx';
import { openStraightBetSlipOnSelect } from '../../../../helpers/openBetSlipMode.tsx';

function FutureComponents() {
    const { activeFutureGames = [], selectedGames } = useSport();
    const [, setShowLimitAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { showModal, updateModalContent } = useModal();

    const onShowBetsModal = (incomingBets?: BetDetails[]) => {
        openStraightBetSlipOnSelect({
            incomingBets,
            showModal,
            updateModalContent,
            setShowLimitAlert,
            setErrorMessage,
        });
    };

    // useEffect(() => {
    // }, [activeFutureGames]);

    const realFutureGames = activeFutureGames.filter(
        (g: any) => !g.isEmpty
    );

    return (
        <>
            {selectedGames && (
                realFutureGames.length > 0 ? (
                    <div className="containertable">
                        {realFutureGames.map((game: any, key: any) => (
                            <FutureGames
                                key={game.id ?? key}
                                game={game}
                                onShowBetsModal={onShowBetsModal}
                                setErrorMessage={setErrorMessage}
                                isLast={key === realFutureGames.length - 1}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="no-data-games">
                        There are currently no future games available for this league.
                    </div>
                )
            )}

            {errorMessage && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setErrorMessage("")}
                />
            )}

        </>
    )
}

export default FutureComponents;
